module.exports = __webpack_public_path__ + "static/img/kanjia.bfd3434c.png";